// extracted by mini-css-extract-plugin
export default {"Option":"Jitqawrf","Content":"lvRQZr3i"};